
export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-24 bg-neutral-800">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-4xl md:text-6xl font-bold text-white leading-tight" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
            POR QUÉ ELEGIR<br />
            <span className="text-neutral-400">DARO TATTOO</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-4 md:mb-6">
          <div 
            className="relative h-[300px] md:h-[500px] overflow-hidden group cursor-pointer"
            style={{ clipPath: 'polygon(0 0, 100% 0, 100% calc(100% - 20px), calc(100% - 20px) 100%, 0 100%)' }}
          >
            <img
              src="https://public.readdy.ai/ai/img_res/73130a2ff659327f395de480c1789f02.jpg"
              alt="Máxima Higiene"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-black/60"></div>
            <div className="absolute bottom-6 md:bottom-8 left-6 md:left-8 right-6 md:right-8">
              <div className="bg-neutral-900/90 backdrop-blur-sm p-4 md:p-6 border border-neutral-700" style={{ clipPath: 'polygon(0 0, 100% 0, 100% calc(100% - 15px), calc(100% - 15px) 100%, 0 100%)' }}>
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center mb-3 md:mb-4">
                  <i className="ri-shield-check-line text-3xl md:text-4xl text-white"></i>
                </div>
                <h3 className="text-white font-bold text-xl md:text-2xl mb-2" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
                  MÁXIMA HIGIENE
                </h3>
                <p className="text-neutral-400 text-xs md:text-sm">
                  Material esterilizado y desechable en cada sesión
                </p>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-4 md:gap-6">
            <div 
              className="relative h-[180px] md:h-[242px] bg-neutral-700 p-6 md:p-8 flex flex-col justify-center items-center text-center group cursor-pointer hover:bg-neutral-600 transition-colors border border-neutral-600"
              style={{ clipPath: 'polygon(0 0, 100% 0, 100% calc(100% - 20px), calc(100% - 20px) 100%, 0 100%)' }}
            >
              <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center mb-3 md:mb-4">
                <i className="ri-award-line text-4xl md:text-5xl text-neutral-300"></i>
              </div>
              <h3 className="text-white font-bold text-lg md:text-xl mb-2" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
                CERTIFICACIÓN PROFESIONAL
              </h3>
              <p className="text-neutral-400 text-xs md:text-sm">
                Formación continua y actualizada
              </p>
            </div>

            <div 
              className="relative h-[180px] md:h-[242px] bg-neutral-900 p-6 md:p-8 flex flex-col justify-center items-center text-center group cursor-pointer hover:bg-neutral-800 transition-colors border border-neutral-700"
              style={{ clipPath: 'polygon(0 0, 100% 0, 100% calc(100% - 20px), calc(100% - 20px) 100%, 0 100%)' }}
            >
              <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center mb-3 md:mb-4">
                <i className="ri-time-line text-4xl md:text-5xl text-neutral-400"></i>
              </div>
              <h3 className="text-white font-bold text-lg md:text-xl mb-2" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
                HORARIO FLEXIBLE
              </h3>
              <p className="text-neutral-400 text-xs md:text-sm">
                Adaptamos las citas a tu disponibilidad
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
          <div 
            className="bg-neutral-900 p-6 md:p-8 text-center hover:bg-neutral-850 transition-all cursor-pointer group border border-neutral-700"
            style={{ clipPath: 'polygon(0 0, 100% 0, 100% calc(100% - 20px), calc(100% - 20px) 100%, 0 100%)' }}
          >
            <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-3 md:mb-4">
              <i className="ri-medal-line text-4xl md:text-5xl text-neutral-500 group-hover:text-neutral-300 transition-colors"></i>
            </div>
            <h3 className="text-white font-bold text-base md:text-lg mb-2" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
              GARANTÍA DE CALIDAD
            </h3>
            <p className="text-neutral-500 text-xs md:text-sm">
              Compromiso con la excelencia en cada trabajo
            </p>
          </div>

          <div 
            className="bg-neutral-900 p-6 md:p-8 text-center hover:bg-neutral-850 transition-all cursor-pointer group border border-neutral-700"
            style={{ clipPath: 'polygon(0 0, 100% 0, 100% calc(100% - 20px), calc(100% - 20px) 100%, 0 100%)' }}
          >
            <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-3 md:mb-4">
              <i className="ri-user-heart-line text-4xl md:text-5xl text-neutral-500 group-hover:text-neutral-300 transition-colors"></i>
            </div>
            <h3 className="text-white font-bold text-base md:text-lg mb-2" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
              ASESORAMIENTO PERSONALIZADO
            </h3>
            <p className="text-neutral-500 text-xs md:text-sm">
              Te ayudamos a crear el diseño perfecto
            </p>
          </div>

          <div 
            className="bg-neutral-900 p-6 md:p-8 text-center hover:bg-neutral-850 transition-all cursor-pointer group border border-neutral-700"
            style={{ clipPath: 'polygon(0 0, 100% 0, 100% calc(100% - 20px), calc(100% - 20px) 100%, 0 100%)' }}
          >
            <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-3 md:mb-4">
              <i className="ri-heart-pulse-line text-4xl md:text-5xl text-neutral-500 group-hover:text-neutral-300 transition-colors"></i>
            </div>
            <h3 className="text-white font-bold text-base md:text-lg mb-2" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
              AFTERCARE INCLUIDO
            </h3>
            <p className="text-neutral-500 text-xs md:text-sm">
              Instrucciones completas para el cuidado
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
